@let client = conversationInfo.subjectData;
<div>
  <button
    pButton
    type="button"
    [outlined]="true"
    class="client-info-button w-full text-left flex items-stretch justify-between pr-0 rounded-lg overflow-hidden focus-visible:ring-2 focus-visible:ring-[var(--p-primary-color)]"
    [ngClass]="{
      'client-selected': selected,
      'client-highlighted': highlight,

    }"
    (click)="onClick()"
  >
    <div
      class="text-left font-normal text-[inherit] text-base leading-normal w-full"
    >
      <div class="w-full flex justify-between">
        <div class="flex items-center gap-3 overflow-hidden">
          <p-avatar
            [label]="initials"
            shape="circle"
            [styleClass]="
              'bg-primary text-white font-medium' +
              (selected ? ' avatar-selected' : '')
            "
            [style]="{ flex: '0 0 auto', width: '2.5rem', height: '2.5rem' }"
            [pTooltip]="collapsed ?  avatarTooltip : undefined"
            tooltipPosition="right"
          ></p-avatar>
          <ng-template #avatarTooltip>
            @if (type==='employee') {
              {{ client.firstName | capitalizeFirst  }} {{ client.lastName | capitalizeFirst  }}<br>
              State: {{ conversationInfo.state }}
            } @else {
              {{ client.firstName | capitalizeFirst  }} {{ client.lastName | capitalizeFirst  }}<br>
              Employee: {{ employee }}
            }
          </ng-template>
          @if(!collapsed) {
            @if (type==='employee') {
              <div class="flex flex-col min-w-0 overflow-hidden">
                <div class="client-info-wrapper">
                  <div class="client-name truncate">
                    {{ client.firstName }} {{ client.lastName }}
                  </div>
                  <div class="client-company truncate">
                    Created: {{ conversationInfo.createdDate | date }}
                  </div>
                  <div class="client-company truncate">
                    Conversation status: {{ conversationInfo.state }}
                  </div>
                </div>
              </div>
            } @else {
              <div class="flex flex-col min-w-0 overflow-hidden">
                <div class="client-info-wrapper">
                  <div class="client-name truncate">
                    {{ client.firstName }} {{ client.lastName }}
                  </div>
                  <div class="client-company truncate">
                    Employee: {{ employee }}
                  </div>
                </div>
              </div>
            }
          }
        </div>


      </div>
    </div>
  </button>
</div>
